import React, { useEffect, useState } from "react";
import { HomeView } from "./home-view";
import { SkillsAssessmentPageView } from './skills-assessment-page-view';
import { CourseOverviewView } from './training-course-video';
import { MainTourWrapper, Card, CardImgDiv, LeftText, CardBody, FooterDiv, CardFooter } from './styles.js'
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
export const PlatformOnboradingTour = (props) => {
    const data = [{
        img: require('../../assets/img/onboarding-changes/1.svg').default,
        title: 'Take the Skills Assessment and Navigate the Free Content',
        about: [`Learn the SmarterChains way!`, `Now you have access to all our Free Content. Explore Studies, Researches, Infographics and more.`, `Start by taking the Skills Assessment to understand your current level of Industry 4.0 readiness.`],
        leftLext: `Welcome to the Industry 4.0 Learning Platform`
    },
    {
        img: require('../../assets/img/onboarding-changes/2.gif').default,
        title: 'The Industry 4.0 Skills Assessment',
        about: [`Assessing the skills of the workforce efficiently is crucial in order to  design educational programs that address the specific needs of the workforce and of the Sustainable Development Goals.`],
    },
    {
        img: require('../../assets/img/onboarding-changes/3.svg').default,
        title: 'Get Certified in Industry 4.0 + Exclusive Content',
        about: [`Click on the Upgrade button and access the only training program of Industry 4.0 that  provides a learning    framework of all the relevant dimensions that can advance Sustainable Development Goals.`,
            `Gain access to further Exclusive Members Content!`],
        leftLext: `Upgrade and Get IR4.0 certified with global recognition`
    },
    {
        img: require('../../assets/img/onboarding-changes/4.gif').default,
        title: 'Step ahead of the Competition',
        about: [`Receive a digital certification following the successful completion of the Trainings and be always on top of the fast evolutions of the Industry 4.0 marketplace.`],
        isBottomlogo: true
    }
    ];

    const exitLink = `/home`;

    const [activeIndex, setActiveIndex] = useState(0);
    useEffect(() => {
        let sideBar = document.querySelector('.ng-sidebar');
        let sideBarToggleBtn = document.querySelector('.ng-toggle-wrap .ng-slide-img ');
        let screenWidth = window.innerWidth;
        if (screenWidth > 575) {
            if (activeIndex == 0) {
                if (sideBar) {
                    sideBar.classList.add('active');
                }
                if (sideBarToggleBtn) {
                    sideBar.classList.add('active');
                }
            } else {
                if (sideBar) {
                    sideBar.classList.remove('active');
                }
                if (sideBarToggleBtn) {
                    sideBar.classList.remove('active');
                }
            }
        }
        return () => {
            if (sideBar) {
                sideBar.classList.remove('active');
            }
            if (sideBarToggleBtn) {
                sideBar.classList.remove('active');
            }
        }
    }, [activeIndex]);
    return (
        <>
            <Helmet>
                <meta name="viewport" content="width=device-width, initial-scale=1" />
            </Helmet>
            {(activeIndex == 0 || activeIndex == 2) ? <HomeView {...props} />
                : activeIndex == 3 ?
                    <CourseOverviewView />
                    :
                    <SkillsAssessmentPageView />
            }

            <MainTourWrapper data-component='MainTourWrapper'>
                {data?.map((item, ind) => (
                    <CardComponent
                        item={item}
                        activeIndex={activeIndex}
                        setActiveIndex={setActiveIndex}
                        index={ind}
                        key={ind}
                        data={data}
                        totalcard={data?.length || 0}
                        exitLink={exitLink}
                        {...props}
                    />
                ))
                }

                <FooterDiv data-componetn="FooterDiv">
                    <button className="title_btn">
                        Training Courses
                    </button>
                    <div>
                        <Link className="exit-link" to={exitLink}>
                            Exit this demo tour
                        </Link>
                    </div>
                </FooterDiv>
            </MainTourWrapper>
        </>
    )
}


const CardComponent = ({ item, index, totalcard, activeIndex, setActiveIndex, data, exitLink }) => {
    useEffect(() => {
        let trainingDiv = document.querySelector('.training-content');
        if (activeIndex == 3 && trainingDiv) {
            trainingDiv.scrollTop = trainingDiv.scrollHeight + 200;
        } else if (trainingDiv) {
            trainingDiv.scrollTop = 0;
        }
    }, [activeIndex])
    return (
        <>
            {activeIndex === index &&
                <Card data-content="Card">
                    <CardImgDiv data-component="CardImgDiv" className="card-1">
                        {item.leftLext &&
                            <LeftText data-component="LeftText">
                                {item.leftLext}
                            </LeftText>
                        }
                        <img src={item.img} />
                    </CardImgDiv>
                    <CardBody data-component="CardBody">
                        <p className="counter-text">{index + 1} of {totalcard}</p>
                        <h2>{item.title}</h2>
                        {item.about.map((para, ind) => (
                            <p key={ind}>{para}</p>
                        )
                        )
                        }
                        {item.isBottomlogo &&
                            <img src={require('../../assets/img/onboarding-changes/logo.svg').default} />
                        }
                    </CardBody>
                    <CardFooter data-component="CardFooter">
                        <div className="left-footer">
                            {data?.map((i, ind) =>
                                <button
                                    className={ind == activeIndex ? "active" : ""}
                                    onClick={() => setActiveIndex(ind)}>
                                </button>
                            )
                            }

                        </div>
                        <div className="right-footer">
                            {index == 0 &&
                                <>
                                    <Link to={exitLink} className="link-btn" >Exit Tour</Link>
                                    <button className="blue-link-btn" onClick={() => setActiveIndex(index + 1)}>Let’s go</button>
                                </>
                            }
                            {(index > 0 && (index < totalcard - 1)) &&
                                <>
                                    <button to="#" className="link-btn"
                                        onClick={() => setActiveIndex(index > 0 ? index - 1 : 0)}>
                                        Previous
                                    </button>
                                    <button className="blue-link-btn"
                                        onClick={() => setActiveIndex(index < totalcard - 1 ? index + 1 : totalcard - 1)}>
                                        Next
                                    </button>
                                </>
                            }
                            {(index == totalcard - 1) &&
                                <>
                                    <button className="link-btn" onClick={() => setActiveIndex(0)}>Restart</button>
                                    <Link to={exitLink} className="blue-link-btn" >Exit Tour</Link>
                                </>
                            }
                        </div>
                    </CardFooter>
                </Card>
            }
        </>
    )
}
